import script from "./ExternalSign.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalSign.vue?vue&type=script&setup=true&lang=js"

import "./ExternalSign.vue?vue&type=style&index=0&id=393075ee&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393075ee"]])

export default __exports__